import React, { useState, useEffect, useRef } from 'react'
import { Button, Card, Modal } from 'antd'
import {
  paginationInit,
  initCurryingObj,
  formatMessageNew,
  dateTrans,
  downLoadFileBlob,
  formatStartTime,
  formatEndTime
} from '@/utils/common'
import {
  getSKUExport,
  getSKUDisableExport,
  getAllInactiveSkuExport,
  getLatestActiveSkuList
} from '@/services/SendList/SendList'
import { configQuery, getTagTypeList } from '@/services/configuration/config'
// import dayjs from 'dayjs'
import { modalSuccess } from '@/utils/modalUtils'
import { uploadSKUs, getNFCSKUList, getNFCUpdateTime } from '@/services/configuration/config'
import AntdTable from '@/components/table/AntdTable'
import UploadBtn from '@/components/Upload/Upload'
import SearchBar from '@/components/searchbar/SearchBar'
import ActionBar from '@/components/table/ActionBar'
import NfcSkuModalTable from './components/nfcSkuModalTable'
import { NFC_SKU_STATUS } from '@/utils/types'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { modalErrorRefreshCode } from '@/utils/modalUtils'
import { hasPermission } from '@/annotations/nike-react'

let errorNumRef = 0
const dateFormat = 'YYYY-MM-DD'
// const dateFormat2 = 'YYYY-MM-DD HH:mm:ss'
// const startMonth = dayjs().subtract(1, 'months')
// const endMonth = dayjs()
const activeStatusObj = initCurryingObj(NFC_SKU_STATUS)
const menu_nfc_nfcSkuUpdate_nfcSkuManagement = 'menu_nfc_nfcSkuUpdate_nfcSkuManagement'
const NFCSKUManagermentPage = () => {
  const language = useSelector(state => state.commonStore.language)
  const tableColumns = [
    {
      title: <div style={{ whiteSpace: 'nowrap' }}>{formatMessageNew('languageObj.commonLocale.productCode')}</div>,
      dataIndex: 'productCode',
      render: text => {
        return (
          <div
            className="link_name"
            onClick={() => {
              tableItemClick(text)
            }}
          >
            {text}
          </div>
        )
      }
    },
    {
      title: <div style={{ whiteSpace: 'nowrap' }}>{formatMessageNew('languageObj.commonLocale.productName')}</div>,
      dataIndex: 'productName',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: <div style={{ whiteSpace: 'nowrap' }}>{formatMessageNew('languageObj.configuration.channel')}</div>,
      dataIndex: 'channel',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: <div style={{ whiteSpace: 'nowrap' }}>{formatMessageNew('languageObj.configuration.plant')}</div>,
      dataIndex: 'plantCode',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: <div style={{ whiteSpace: 'nowrap' }}>{formatMessageNew('languageObj.configuration.tagType')}</div>,
      dataIndex: 'tagType',
      render: (text, record) => {
        if (text) {
          let ls = text.split(',')
          let tagTypeDesc = record.tagTypeDesc.split(',')
          return ls.map((item, idx) => {
            return (
              <div key={idx} className="word_break_word">
                <span className="tagType">{item}</span>
                <span className="splitSpan">-</span>
                {tagTypeDesc[idx]}
                {idx < ls.length - 1 ? ',' : ''}
              </div>
            )
          })
        } else {
          return <div className="word_break_word">{text}</div>
        }
      }
    },
    {
      title: <div style={{ whiteSpace: 'nowrap' }}>{formatMessageNew('languageObj.commonLocale.status')}</div>,
      dataIndex: 'nfcStatus',
      render: text => {
        if (text) {
          return activeStatusObj['Active']
        } else {
          return activeStatusObj['Inactive']
        }
      }
    },
    {
      title: <div style={{ whiteSpace: 'nowrap' }}>{formatMessageNew('languageObj.configuration.createTime')}</div>,
      dataIndex: 'createTime',
      render: text => {
        return dateTrans(text, true)
      }
    },
    {
      title: <div style={{ whiteSpace: 'nowrap' }}>{formatMessageNew('languageObj.configuration.lastUpdate')}</div>,
      dataIndex: 'operator'
    },
    {
      title: <div style={{ whiteSpace: 'nowrap' }}>{formatMessageNew('languageObj.configuration.lastUploadTime')}</div>,
      dataIndex: 'uploadTime',
      render: text => {
        return dateTrans(text, true)
      }
    },
    {
      title: <div style={{ whiteSpace: 'nowrap' }}>{formatMessageNew('languageObj.configuration.lastUpdateTime')}</div>,
      dataIndex: 'updateTime',
      render: text => {
        return dateTrans(text, true)
      }
    }
  ]
  const mounting = useRef(false)
  let formRef = useRef(null)
  let searchListInit = [
    {
      type: 'input',
      label: 'languageObj.commonLocale.productCode',
      key: 'productCode',
      initialValues: '',
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.configuration.channel',
      key: 'channel',
      // initialValues: '',
      selectList: [],
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.commonLocale.tagTypeDesc',
      key: 'tagTypeDesc',
      initialValues: '',
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'timeRange',
      label: 'languageObj.configuration.createDate',
      key: 'createDate',
      format: dateFormat,
      isdefaultfilter: 'true',
      disabledDate: current => {
        let falg =
          (current &&
            current <
              moment()
                .subtract(1, 'year')
                .subtract(1, 'day')) ||
          (current && current > moment().endOf('day'))
        return falg
      },
      // initialValues: [startMonth, endMonth],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'timeRange',
      label: 'languageObj.configuration.uploadDate',
      key: 'uploadDate',
      format: dateFormat,
      isdefaultfilter: 'true',
      disabledDate: current => {
        let falg =
          (current &&
            current <
              moment()
                .subtract(1, 'year')
                .subtract(1, 'day')) ||
          (current && current > moment().endOf('day'))
        return falg
      },
      // initialValues: [startMonth, endMonth],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'timeRange',
      label: 'languageObj.configuration.updateDate',
      key: 'updateDate',
      format: dateFormat,
      isdefaultfilter: 'true',
      disabledDate: current => {
        let falg =
          (current &&
            current <
              moment()
                .subtract(1, 'year')
                .subtract(1, 'day')) ||
          (current && current > moment().endOf('day'))
        return falg
      },
      // initialValues: [startMonth, endMonth],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.configuration.plant',
      key: 'plant',
      // initialValues: '',
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.configuration.tagType',
      key: 'tagTypeList',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.commonLocale.status',
      key: 'status',
      selectList: [
        { value: true, label: 'Active' },
        { value: false, label: 'Inactive' }
      ],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.configuration.lastUpdate',
      key: 'lastUpdateBy',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    }
  ]

  const [tableList, setTableList] = useState([])
  const [searchList, setSearchList] = useState(searchListInit)
  const [updateTime, setUpdateTime] = useState(0)
  const [queryFlag, setQueryFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const [modalVisible, setModalVisible] = useState(false)
  const [selectProductCode, setSelectProductCode] = useState(false)

  useEffect(() => {
    lastUpdateTime()
    getDictionnaryDropListFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const getDictionnaryDropListFun = () => {
    let num = 99999999
    const params1 = {
      configKey: 'plant_code',
      configStatus: true,
      configType: 'plant_code_config',
      pageNo: 1,
      size: num,
      total: num
    }

    const params2 = {
      configKey: 'channel',
      configStatus: true,
      configType: 'channel_config',
      pageNo: 1,
      size: num,
      total: num
    }

    const params3 = {
      description: '',
      configStatus: true,
      pageNo: 1,
      size: num,
      total: num
    }
    Promise.all([configQuery(params1), configQuery(params2), getTagTypeList(params3)]).then(res => {
      try {
        searchListInit.forEach(searchItem => {
          if (['channel', 'plant', 'tagTypeList'].includes(searchItem.key)) {
            let options = []
            switch (searchItem.key) {
              case 'plant':
                const plantCodeList = res[0].resultData.records
                const plantOptions = plantCodeList.map(item => ({ value: item.configValue, text: item.configValue }))
                options = [{ test: 'All', value: '' }, ...plantOptions]
                break
              case 'channel':
                const channelList = res[1].resultData.records
                options = channelList.map(item => ({ value: item.configValue, text: item.configValue }))
                break
              case 'tagTypeList':
                const tagTypeList = res[2].resultData.records
                options = tagTypeList.map(item => ({ value: item.type, text: item.type }))
                break
              default:
                break
            }
            searchItem.selectList = options
          }
        })
        setSearchList([...searchListInit])
      } catch (error) {}
    })
  }
  const lastUpdateTime = () => {
    getNFCUpdateTime({}).then(res => {
      if (res.errorCode === '200') {
        if (res?.resultData > 0) {
          setUpdateTime(res.resultData)
        }
      }
    })
  }

  useEffect(() => {
    if (mounting.current) searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  const searchDataBtn = () => {
    const pg = {
      ...pagination,
      currentPage: 1
    }
    mounting.current = true
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    formRef && formRef.current.clearForm()
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const handleTableChange = (pagina, sorter, extra) => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }
  const getParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const { uploadDate, updateDate, createDate } = info
    const params = {
      productCode: info.productCode,
      tagTypeDesc: info.tagTypeDesc,
      status: info.status,
      lastUpload: info.lastUpload,
      channel: info.channel,
      plant: info.plant,
      tagTypeList: info.tagTypeList,
      lastUpdateBy: info.lastUpdateBy,
      uploadDateStart: formatStartTime(uploadDate),
      uploadDateEnd: formatEndTime(uploadDate),
      updateDateStart: formatStartTime(updateDate),
      updateDateEnd: formatEndTime(updateDate),
      createDateStart: formatStartTime(createDate),
      createDateEnd: formatEndTime(createDate)
    }
    return params
  }
  const searchDataFun = () => {
    const params = {
      ...getParams(),

      size: pagination.pageSize,
      pageNo: pagination.currentPage,
      total: pagination.total
    }
    getNFCSKUList(params).then(res => {
      const dt = res.resultData
      setTableList(dt.records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }

  const getUpdateHtml = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
        {/* <UploadBtn
          uploadAjax={file => uploadFun(file)}
          btnName={formatMessageNew( 'languageObj.nspskuLocale.uploadNFCSKU')}
        /> */}
        {updateTime !== 0 ? (
          <div style={{ marginRight: '20px', display: 'flex', alignItems: 'center' }}>
            {formatMessageNew('languageObj.nspskuLocale.updatedTime')}
            {moment(new Date(updateTime)).format('YYYY-MM-DD HH:mm:ss')}
          </div>
        ) : null}
      </div>
    )
  }
  const contentHtml = data => {
    return (
      <div>
        <div style={{ display: 'flex' }}>
          <div>
            {formatMessageNew('languageObj.configuration.totalSKUCount')}
            {data.total}
          </div>
          <div style={{ marginLeft: '20px' }}>
            {formatMessageNew('languageObj.configuration.processSuccessCount')}
            {data.successCount}
          </div>
        </div>
        <div style={{ margin: '20px 0 0 0', fontWeight: 500 }}>
          <span style={{ fontWeight: 700 }}>
            {formatMessageNew('languageObj.configuration.compareWithLastVersion')}
          </span>
        </div>
        <div style={{ display: 'flex' }}>
          <div>
            {formatMessageNew('languageObj.configuration.inactiveSKUCount')}
            {data.disableCount}
          </div>
          <div style={{ marginLeft: '20px' }}>
            {formatMessageNew('languageObj.configuration.newSKUCount')}
            {data.newSku}
          </div>
        </div>
      </div>
    )
  }
  const uploadFun = file => {
    // file.append('account', account)
    uploadSKUs(file)
      .then(res => {
        if (res.errorCode === '200') {
          const data = res.resultData
          modalSuccess({
            content: contentHtml(data)
          })
          setQueryFlag(!queryFlag)
          lastUpdateTime()
        }
      })
      .catch(error => {
        if (errorNumRef === 0) {
          errorNumRef = 1
          let msg = ''
          if (error.errorCode === '499') {
            const data = error.resultData || {}
            const keys = Object.keys(data)
            if (keys.indexOf('423') !== -1) {
              msg += formatMessageNew('languageObj.configuration.errorcode_423') + data['423'].join('、') + '<br/>'
            }
            if (keys.indexOf('424') !== -1) {
              msg += formatMessageNew('languageObj.configuration.errorcode_424') + '<br/>'
            }
            if (keys.indexOf('425') !== -1) {
              msg += formatMessageNew('languageObj.configuration.errorcode_425') + data['425'].join('、') + '<br/>'
            }
            if (keys.indexOf('1603') !== -1) {
              msg += formatMessageNew('languageObj.configuration.errorcode_1603') + data['1603'].join('、') + '<br/>'
            }
            if (keys.indexOf('1304') !== -1) {
              if (data['1304'].length > 0) {
                msg +=
                  formatMessageNew('languageObj.configuration.errorcode_13041') +
                  data['1304'].join('、') +
                  formatMessageNew('languageObj.configuration.errorcode_13042') +
                  '<br/>'
              } else {
                msg += formatMessageNew('languageObj.configuration.errorcode_1304') + '<br/>'
              }
            }
            if (keys.indexOf('1305') !== -1) {
              msg += formatMessageNew('languageObj.configuration.errorcode_1305') + '<br/>'
            }
            if (keys.indexOf('1604') !== -1) {
              msg += formatMessageNew('languageObj.configuration.errorcode_1604') + data['1604'].join('、')
            }
          }
          if (error.errorCode === '801') {
            msg = formatMessageNew('languageObj.configuration.errorcode_801')
          }
          if (error.errorCode === '821') {
            msg = formatMessageNew('languageObj.configuration.errorcode_821')
          }
          if (error.errorCode === '1111') {
            msg = formatMessageNew('languageObj.configuration.errorcode_1111')
          }
          if (error.errorCode === '1801') {
            msg = formatMessageNew('languageObj.configuration.errorcode_1801')
          }
          modalErrorRefreshCode(
            {
              content: msg
            },
            () => {
              errorNumRef = 0
            }
          )
        }
      })
  }

  const downLoadFun = () => {
    const params = {
      ...getParams(),
      isChinese: language === 'zh_CN' ? true : false
    }
    // delete params.uploadDate
    getSKUExport(params).then(res => {
      downLoadFileBlob(res)
    })
  }

  const downLoadDisableFun = () => {
    const params = {
      isChinese: language === 'zh_CN' ? true : false
    }
    getSKUDisableExport(params).then(res => {
      downLoadFileBlob(res)
    })
  }

  const downloadAllInactiveSkuExport = () => {
    const params = {
      isChinese: language === 'zh_CN' ? true : false
    }
    getAllInactiveSkuExport(params).then(res => {
      downLoadFileBlob(res)
    })
  }

  const downloadLatestActiveSkuList = () => {
    const params = {
      isChinese: language === 'zh_CN' ? true : false
    }
    getLatestActiveSkuList(params).then(res => {
      downLoadFileBlob(res)
    })
  }

  const tableItemClick = code => {
    setSelectProductCode(code)
    setModalVisible(true)
  }

  const handleModalCancel = () => {
    setModalVisible(false)
  }

  const handleModalOk = () => {
    setModalVisible(false)
  }

  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar
            ref={formRef}
            searchList={searchList}
            showCollapseBtn={true}
            showSearchBtn={true}
            showClearBtn={true}
            onSearch={searchDataBtn}
            onClear={searchClearDataBtn}
          />
        </div>
        <div className="content-container">
          <ActionBar onDownload={downLoadFun} />
          <AntdTable
            title={() => {
              return (
                <>
                  <div style={{ display: 'flex' }}>
                    {getUpdateHtml()}
                    {hasPermission(menu_nfc_nfcSkuUpdate_nfcSkuManagement) && (
                      <>
                        <UploadBtn
                          uploadAjax={file => uploadFun(file)}
                          btnName={formatMessageNew('languageObj.nspskuLocale.uploadNFCSKU')}
                        />
                      </>
                    )}
                    <Button type="primary" onClick={downloadLatestActiveSkuList} style={{ marginLeft: '20px' }}>
                      {formatMessageNew('languageObj.commonLocale.exportLatestActiveSKUList')}
                    </Button>
                    <Button type="primary" onClick={downLoadDisableFun} style={{ marginLeft: '20px' }}>
                      {formatMessageNew('languageObj.commonLocale.failureList')}
                    </Button>
                    <Button type="primary" onClick={downloadAllInactiveSkuExport} style={{ marginLeft: '20px' }}>
                      {formatMessageNew('languageObj.commonLocale.exportAllInactiveSKU')}
                    </Button>
                    {/* <Button type="primary" onClick={downLoadFun} style={{ marginLeft: '20px' }}>
                      {formatMessageNew('languageObj.commonLocale.export')}
                    </Button> */}
                  </div>
                </>
              )
            }}
            dataSource={tableList}
            columns={tableColumns}
            pagination={pagination}
            // 独一无二的标识，不能重复
            columnsKey="nfcSkuManagementColumns"
            onChange={handleTableChange}
          />
        </div>
      </Card>
      <Modal
        open={modalVisible}
        maskClosable={false}
        className="nike_modal"
        width="70%"
        title={formatMessageNew('languageObj.nspskuLocale.skuHistory')}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        footer={null}
      >
        {modalVisible ? <NfcSkuModalTable productCode={selectProductCode} /> : <></>}
      </Modal>
    </div>
  )
}
export default NFCSKUManagermentPage
